import {UseQueryResult} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {LIMS_MEASUREMENT_TYPES_QUERY_KEY} from '../../api/queries/getLimsMeasurementTypes'
import {LimsMeasurementType} from '../../types/LimsMeasurementType'

import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export function useLimsMeasurementTypesQuery(): UseQueryResult<LimsMeasurementType[]> {
  const plantCode = useUrlParam('plantCode')
  const {t} = useTranslation()

  return useSettingsQuery(LIMS_MEASUREMENT_TYPES_QUERY_KEY, [plantCode], {
    meta: {
      errorMessage: t('measurementsSettings.queryError', {
        entity: 'Lims Measurement Types'
      })
    }
  })
}
